function saveFile(url, name) {
    var element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', name);
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

export { saveFile };